export const NEW_PLATFORMS = ['Epic Games']
